import { render, staticRenderFns } from "./UserVendors.vue?vue&type=template&id=1e2e7988"
import script from "./UserVendors.vue?vue&type=script&lang=js"
export * from "./UserVendors.vue?vue&type=script&lang=js"
import style0 from "./UserVendors.vue?vue&type=style&index=0&id=1e2e7988&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports